var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/cell_phone/index.js
 ** module id = 1088
 ** module chunks = 0
 **/